function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { PureComponent } from "react";
import PersonInfo from "segments/desktop/core-components/person-info/person-info";
import TestimonialsQuote from "segments/desktop/core-components/testimonials-quote/testimonials-quote";
import Title from "segments/desktop/core-components/title/title";
import { StyledFullTestimonialsQuote } from "./full-testimonials-quote.scss";
import DefaultProps from "./default-props";
class FullTestimonialsQuote extends PureComponent {
    render() {
        const { testimonialsConfig, personConfig, title, titleSize, maxWidth } = this.props;
        return /*#__PURE__*/ _jsxs(StyledFullTestimonialsQuote, {
            className: "full-testimonials-quote",
            style: {
                maxWidth
            },
            children: [
                /*#__PURE__*/ _jsx("div", {
                    className: "full-testimonials-title",
                    children: /*#__PURE__*/ _jsx(Title, {
                        title: title,
                        titleSize: titleSize
                    })
                }),
                /*#__PURE__*/ _jsx(TestimonialsQuote, _object_spread({}, testimonialsConfig)),
                /*#__PURE__*/ _jsx(PersonInfo, _object_spread({}, personConfig))
            ]
        });
    }
}
export { FullTestimonialsQuote as default };
FullTestimonialsQuote.defaultProps = DefaultProps;
